import { CampaignPrizeListResponse } from '@/modules/draw/campaigns/services/apiValidation/campaignPrizeListApiValidation.ts'

export const campaignPrizesPage1: { data: CampaignPrizeListResponse } = {
  data: {
    results: [
      {
        id: 1,
        name: 'Recarga de $10',
        description: 'Recarga directa a la billetera del ganador.',
        prizeType: 'RECHARGE',
        valueAmount: '10.00',
        quantity: 10,
        position: 1,
        isActive: true,
        campaignId: 1,
        campaignName: 'Campaña de Verano'
      },
      {
        id: 2,
        name: 'Recarga de $25',
        description: 'Recarga directa a la billetera del ganador.',
        prizeType: 'RECHARGE',
        valueAmount: '25.00',
        quantity: 5,
        position: 2,
        isActive: true,
        campaignId: 1,
        campaignName: 'Campaña de Verano'
      }
    ],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 2,
      range: [1],
      count: 2,
      pages: 1,
      total: 2,
      limit: 20
    }
  }
}
